var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isDraft)?_c('div',{staticClass:"n-msg-pl elevation-12"},[_c('message-editable',{attrs:{"index":_vm.index}})],1):_c('div',[_c('message-display',{attrs:{"index":_vm.index}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }